import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";
import SmoothScroll from "@/components/SmoothScroll";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Expertise from "@/pages/Expertise";
import Experience from "@/pages/Experience";
import Approach from "@/pages/Approach";
import Contact from "@/pages/Contact";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";

export default function App() {
    return (
        <BrowserRouter>
            <Seo />
            <SmoothScroll />
            <div className="grain" aria-hidden />
            <div className="min-h-screen bg-[#0B1322] text-[#E8ECF4]">
                <Navbar />
                <main>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/expertise" element={<Expertise />} />
                        <Route path="/experience" element={<Experience />} />
                        <Route path="/approach" element={<Approach />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                        <Route path="/terms" element={<Terms />} />
                        <Route path="*" element={<Home />} />
                    </Routes>
                </main>
                <Footer />
            </div>
            <Toaster position="bottom-right" />
        </BrowserRouter>
    );
}
